// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "::v-deep :not(.v-icon_20t-z){font-family:\"proxima-nova\",\"OpenSans\",\"Pridi\",\"NotoSans\",\"NotoSansSC\",\"NotoSansHebrew\",\"NotoSansJapanese\",\"Hiragino Kaku Gothic Pro\",\"Yu Gothic Medium\",\"Yu Gothic\",Meiryo,\"source-han-sans-japanese\",\"source-han-sans-korean\",\"source-han-sans-simplified-c\",Helvetica,Arial,sans-serif}.nsAddressForm_wl3W0 .dualColumn_1JP1w{display:flex;align-content:space-between}.nsAddressForm_wl3W0 .dualColumn_1JP1w .firstCol_23pnh{margin-right:20px}.optional_QnvtS{color:#bbbcbc}", ""]);
// Exports
exports.locals = {
	"v-icon": "v-icon_20t-z",
	"nsAddressForm": "nsAddressForm_wl3W0",
	"dualColumn": "dualColumn_1JP1w",
	"firstCol": "firstCol_23pnh",
	"optional": "optional_QnvtS"
};
module.exports = exports;
